import React, { useEffect, useMemo } from 'react';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import type { VenueInventory } from '../../utils/inventory';
interface VenueMapProps {
  venues: VenueInventory[];
  center: [number, number];
  selectedId: string | null;
  onSelect: (id: string) => void;
  visibleKey: string;
}
function pinIcon(n: number, active: boolean): L.DivIcon {
  const size = active ? 38 : 32;
  const bg = active ? '#E8312F' : '#1C2369';
  return L.divIcon({
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
    html: `<div style="width:${size}px;height:${size}px;background:${bg};border:2px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;transition:background-color 150ms ease-out"><span style="transform:rotate(45deg);color:#fff;font:700 ${active ? 15 : 13}px Inter,sans-serif">${n}</span></div>`
  });
}
function MapController({
  venues,
  selectedId,
  visibleKey
}: {
  venues: VenueInventory[];
  selectedId: string | null;
  visibleKey: string;
}) {
  const map = useMap();
  useEffect(() => {
    if (!venues.length) return;
    map.fitBounds(L.latLngBounds(venues.map(v => [v.lat, v.lng] as [number, number])), {
      padding: [48, 48],
      maxZoom: 12
    });
  }, [venues, map]);
  useEffect(() => {
    const v = venues.find(x => x.id === selectedId);
    if (v) map.flyTo([v.lat, v.lng], Math.max(map.getZoom(), 12), {
      duration: 0.5
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId]);
  useEffect(() => {
    const t = window.setTimeout(() => map.invalidateSize(), 60);
    return () => window.clearTimeout(t);
  }, [visibleKey, map]);
  return null;
}
export function VenueMap({
  venues,
  center,
  selectedId,
  onSelect,
  visibleKey
}: VenueMapProps) {
  const icons = useMemo(() => venues.map((v, i) => ({
    id: v.id,
    normal: pinIcon(i + 1, false),
    active: pinIcon(i + 1, true)
  })), [venues]);
  return <MapContainer center={center} zoom={10} scrollWheelZoom={false} className="isolate h-full w-full" data-id="element-97" data-mp="2mt7gq980l7mk">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/">CARTO</a>' url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" data-id="element-98" data-mp="31qgizxyuvvt2" />
      {venues.map((v, i) => <Marker key={v.id} position={[v.lat, v.lng]} icon={selectedId === v.id ? icons[i].active : icons[i].normal} title={v.name} zIndexOffset={selectedId === v.id ? 1000 : 0} eventHandlers={{
      click: () => onSelect(v.id)
    }} data-id="element-99" data-mp="3aosas3bgkzn3" data-mpi={i} />)}
      <MapController venues={venues} selectedId={selectedId} visibleKey={visibleKey} data-id="element-100" data-mp="3thmeg13mt5c0" />
    </MapContainer>;
}